import React, { useEffect, useState } from "react"
import { SunIcon, MoonIcon } from "@heroicons/react/20/solid"

type DarkModeToggleProps = {
  className?: string
}

const DarkModeToggle: React.FC<DarkModeToggleProps> = ({ className = "" }) => {
  const [darkMode, setDarkMode] = useState<boolean>(() => {
    if (typeof window !== "undefined") {
      const storedMode = localStorage.getItem("darkMode")
      if (storedMode !== null) {
        return storedMode === "true"
      }
    }
    return true // Default to dark mode
  })

  useEffect(() => {
    if (typeof window === "undefined") return

    localStorage.setItem("darkMode", darkMode.toString())

    if (darkMode) {
      document.documentElement.classList.add("dark")
    } else {
      document.documentElement.classList.remove("dark")
    }
  }, [darkMode])

  const handleClick = () => setDarkMode(prev => !prev)

  return (
    <div className={`flex items-center ${className}`}>
      {darkMode ? (
        <MoonIcon onClick={handleClick} className="size-5 text-text-secondary hover:text-text-primary cursor-pointer transition-colors" />
      ) : (
        <SunIcon onClick={handleClick} className="size-5 text-text-secondary hover:text-text-primary cursor-pointer transition-colors" />
      )}
    </div>
  )
}

export default DarkModeToggle
